<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { todaycode, transformCodeToDate } from '@/functions/utils';
import CulturesComponent from '@/components/CulturesComponent.vue'
import HistoricalData from '@/components/HistoricalData.vue';
import { useDataStore } from '@/stores/useDataStore';
const dataStore = useDataStore();

onMounted(async () => {
  dataStore.showCreateCulture = false;
  dataStore.newCulture.startdaycode.startday_code = todaycode;
  dataStore.newCulture.pbr.id = 0
  dataStore.newCulture.specie.id = 0
  dataStore.filtreEspece = null
  dataStore.filtrePBR = null
});

watch(() => dataStore.selectedCulture, (newVal: Culture | null) => {
  if (newVal) {
    const today = new Date();
    const startDateStr = transformCodeToDate(newVal.startdaycode.startday_code); // format YYYY-MM-DD
    const startDate = new Date(startDateStr);
    const age_in_days = Math.floor((today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));

    dataStore.enrichedCulture = {
      ...newVal,
      age_in_days,
      number_of_harvests: newVal.recoltes?.length || 0,
      number_of_samples: newVal.prelevements?.length || 0,
    };
  } else {
    dataStore.enrichedCulture = null;
  }
});

watch(
  () => [dataStore.filtreEspece, dataStore.filtrePBR],
  () => {
    dataStore.selectedCulture = null;
  }
);

import { useAuthStore } from '@/stores/useAuthStore'
const authStore = useAuthStore();
</script>

<template>
  <div v-if="authStore.scopes.includes('reader')">
    <div>
      <h1>Historique</h1>
    </div>

    <div v-if="dataStore.isDataLoading" class="spinner-container module">
      <div class="spinner"></div>
      <p>{{ $t('loadingData') }}</p>
    </div>

    <div v-else class="module">
      <CulturesComponent />
    </div>

    <div>
      <HistoricalData />
    </div>
  </div>

  <div v-if="!authStore.isAuthenticated" class="centered-block">
    <h2>{{ $t('loginRequiredTitle') }}</h2>
    <p>{{ $t('loginRequiredMessage') }}</p>
  </div>
</template>